import Loadable from '../../components/loadable';
import ModalPlaceholder from '../../components/modal_placeholder';

const RecurringBookingSummariesReport = Loadable({
  loader: () =>
    import(
      '../../pages/reports/recurring_booking_summaries_report/recurring_booking_summaries_report'
    ),
});

angular.module('gym').value('RecurringBookingSummariesReport', RecurringBookingSummariesReport);

const RecurringBookingSummariesReportFiltersModal = Loadable({
  loader: () =>
    import(
      '../../pages/reports/recurring_booking_summaries_report/recurring_booking_summaries_report_filters_modal'
    ),
  loading: ModalPlaceholder,
});

angular
  .module('gym')
  .value(
    'RecurringBookingSummariesReportFiltersModal',
    RecurringBookingSummariesReportFiltersModal,
  );
